import React, { Component } from "react";
import { Button, Modal } from "antd";
import GetInTouch from "../../utils/getInTouch";

class Ads extends Component {
  state = {
    open: false,
  };

  showModal = () => {
    this.setState({ open: true });
  };

  handleCancel = () => {
    this.setState({ open: false });
  };

  render() {
    const publicUrl = process.env.PUBLIC_URL + "/";
    const inlineStyle = {
      backgroundImage: `url(${publicUrl}assets/img/bg/featuredimg.jpeg)`,
    };

    return (
      <div className="call-to-action-area pd-top-70">
        <div className="container">
          <div className="call-to-action" style={inlineStyle}>
            <div className="cta-content">
              <div className="text-block">
                <h4 className="title">Your Exclusive Invitation For Booking Your Dream Home.
                </h4>
                <p className="para">Feel free to contact us, Our Professional team is always here to help you</p>
              </div>
              <Button className="btn btn-white" style={{ backgroundColor: "orange", color: "#ffff"}} onClick={this.showModal}>
                GET IN TOUCH
              </Button>
            </div>
          </div>
        </div>

        {/* Modal containing GetInTouch form */}
        <Modal
          title=""
          open={this.state.open}
          onCancel={this.handleCancel}
          footer={null}
        >
          <GetInTouch onClose={this.handleCancel} />
        </Modal>
      </div>
    );
  }
}

export default Ads;
